import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { saveAs } from 'file-saver';
import { take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { ATTORNEY, PETITIONER } from 'app-models';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { sync_petitioner_document_code } from 'permission-library';
import * as i5 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { environment } from 'environment-configurations';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i6 from 'primeng/dynamicdialog';
import * as i7 from 'app-services-library';

class APIPetitionerDetails {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPetitionerDetails(visatype, companyId, superTaskId, subTaskId) {
        return this.httpClient.get(`/${visatype}/company/${companyId}/petitionerDetails?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204))
                return response;
        }));
    }
    // syncDocument(superTaskId, subTaskId, caseId, categoryCode) {
    //   return this.httpClient.post(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/${caseId}/profileDoc/category/${categoryCode}/sync`, {}).pipe(
    //     map((response: ImagilityBaseResponse) => {
    //       if (response && response.status === 200) {
    //         return response;
    //       }
    //     })
    //   );
    // }
    getPetitionerUploadDetails(visatype, caseType, caseId, companyId, synccode) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/company/${companyId}/${synccode}`, {}).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getPetitionerUploaUSDetails(visatype, caseType, caseId, synccode, superTaskId, subTaskId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/PETITIONER/${synccode}?superTaskId=0&taskId=0`, {}).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    syncProfileUSData(visatype, caseType, caseId, categoryCode) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/PETITIONER/category/${categoryCode}/sync`, {}).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    syncProfileForeignData(visatype, caseType, caseId, groupId, categoryCode) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/PETITIONER/${groupId}/category/${categoryCode}/sync`, {}).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    postAdditionalInfo(visatype, caseType, caseId, payload) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/additionalInfo`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getAdditionalInfo(visatype, caseType, caseId, superTaskId, subTaskId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/additionalInfo/PTLTRLIST?superTaskId=${superTaskId}&taskId=${subTaskId}
    `).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    downloadDocuments(path, fileName) {
        this.httpClient.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    deleteDocuments(visatype, caseType, caseId, documentId) {
        return this.httpClient.delete(`/${visatype}/${caseType}/${caseId}/document/${documentId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
APIPetitionerDetails.ɵfac = function APIPetitionerDetails_Factory(t) { return new (t || APIPetitionerDetails)(i0.ɵɵinject(i1.HttpClient)); };
APIPetitionerDetails.ɵprov = i0.ɵɵdefineInjectable({ token: APIPetitionerDetails, factory: APIPetitionerDetails.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIPetitionerDetails, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const DeleteDialogConfigurations = {
    width: '30%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
const NoteDialogConfigurations = {
    width: '40%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    data: {}
};
class BasePetitionerDetailsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, dialogService, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.dialogService = dialogService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.disabledControls = false;
        this.template = {
            body: ''
        };
        this.petitionerDocumentList = [];
        this.h1BPetitionerDocumentList = [];
        this.userType = sessionStorage.getItem('userTypeRole');
        this.notifyDestinationUser = this.userType === ATTORNEY ? PETITIONER : null;
    }
    loadInit() {
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
            this.stepDetails = data;
            this.getPetitionerDetails();
            this.getAdditionalInfoDetails();
            this.getPetitionerDocumentDetails();
            this.fileUploadUSConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getDocTypeApiUrl: `/${this.inputData.visatype}/petitionType/${this.inputData.petitionType}/group/${this.inputData.visatype === 'H1-B' ? 'COMPOTHDOC' : sync_petitioner_document_code.SYNC_TASK_TYPE_Code_US}/documentTypes`,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code_US}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code_US}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: ''
            });
            this.fileUploadForeignConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getDocTypeApiUrl: `/${this.inputData.visatype}/petitionType/${this.inputData.petitionType}/group/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code}/documentTypes`,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: ''
            });
            // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
            //   this.updateStepStatus('INPROGRESS');
            // }
            this.toggleControlsStatus();
        });
    }
    afterViewInit() {
        this.petitionerDocumentForm.form.valueChanges.pipe(takeUntil(this.observableSubscription$), map(() => this.petitionerDocumentForm.dirty)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    syncPetitionerDocuments() {
        if (this.isForeignCompany) {
            this.apiService.syncProfileForeignData(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.foreignCompanyId, sync_petitioner_document_code.SYNC_TASK_TYPE_Code_Sync).subscribe((response) => {
                if (response && response.status === 200) {
                    this.toastr.success(response.message, 'Success');
                    this.fileUploadUSConfigurations = Object.assign({}, this.fileUploadForeignConfigurations);
                    this.getPetitionerDocumentDetails();
                }
            });
        }
        else {
            this.apiService.syncProfileUSData(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_petitioner_document_code.SYNC_TASK_TYPE_Code_Sync).subscribe((response) => {
                if (response && response.status === 200) {
                    this.toastr.success(response.message, 'Success');
                    this.fileUploadUSConfigurations = Object.assign({}, this.fileUploadUSConfigurations);
                    this.getPetitionerDocumentDetails();
                }
            });
        }
    }
    getPetitionerDetails() {
        if (this.isForeignCompany) {
            this.apiService.getPetitionerDetails(this.inputData.visatype, this.inputData.foreignCompanyId, this.inputData.superTaskId, this.inputData.subTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.petitionerDetails = response.data;
            });
        }
        else {
            this.apiService.getPetitionerDetails(this.inputData.visatype, this.inputData.companyId, this.inputData.superTaskId, this.inputData.subTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.petitionerDetails = response.data;
            });
        }
    }
    getPetitionerDocumentDetails() {
        // To fetch company documents
        this.apiService.getPetitionerUploaUSDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_petitioner_document_code.SYNC_TASK_TYPE_Code_Sync, this.inputData.superTaskId, this.inputData.subTaskId).subscribe((response) => {
            if (response && response.data) {
                this.h1BPetitionerDocumentList = response.data; // Company level document list
            }
        });
        // To petitioner documents
        if (this.isForeignCompany) {
            this.apiService.getPetitionerUploadDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.foreignCompanyId, sync_petitioner_document_code.SYNC_TASK_TYPE_Code).subscribe((response) => {
                if (response && response.data) {
                    this.petitionerDocumentList = response.data;
                    this.fileUploadUSConfigurations = Object.assign({}, this.fileUploadForeignConfigurations);
                }
            });
        }
        else {
            this.apiService.getPetitionerUploaUSDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_petitioner_document_code.SYNC_TASK_TYPE_Code, this.inputData.superTaskId, this.inputData.subTaskId).subscribe((response) => {
                if (response && response.data) {
                    this.petitionerDocumentList = response.data;
                    this.fileUploadUSConfigurations = Object.assign({}, this.fileUploadUSConfigurations);
                }
            });
        }
    }
    getAdditionalInfoDetails() {
        this.apiService.getAdditionalInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.data) {
                this.toastr.success(response.message, 'Success');
                this.template.body = response.data.additionalText;
                // this.fileUploadUSConfigurations = Object.assign({}, this.fileUploadUSConfigurations);
            }
        });
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    download(file) {
        this.apiService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
    }
    deleteImmigrationDocuments(item) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getPetitionerDocumentDetails();
                });
            }
        });
    }
    postFormSubmission() {
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
        this.fileUploadUSConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getDocTypeApiUrl: `/${this.inputData.visatype}/petitionType/${this.inputData.petitionType}/group/${this.inputData.visatype === 'H1-B' ? 'COMPOTHDOC' : sync_petitioner_document_code.SYNC_TASK_TYPE_Code_US}/documentTypes`,
            getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'COMPOTHDOC' : sync_petitioner_document_code.SYNC_TASK_TYPE_Code_US}/`,
            postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'COMPOTHDOC' : sync_petitioner_document_code.SYNC_TASK_TYPE_Code_US}/fileCategory/`,
            deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            documentTypeDropdownCode: ''
        });
        this.fileUploadForeignConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getDocTypeApiUrl: `/${this.inputData.visatype}/petitionType/${this.inputData.petitionType}/group/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code}/documentTypes`,
            getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code}/`,
            postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${sync_petitioner_document_code.SYNC_TASK_TYPE_Code}/fileCategory/`,
            deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            documentTypeDropdownCode: ''
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BasePetitionerDetailsLibraryService.ɵfac = function BasePetitionerDetailsLibraryService_Factory(t) { return new (t || BasePetitionerDetailsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIPetitionerDetails), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DirtyFormGuard), i0.ɵɵinject(i6.DialogService), i0.ɵɵinject(i7.AppServicesLibraryService)); };
BasePetitionerDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BasePetitionerDetailsLibraryService, factory: BasePetitionerDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasePetitionerDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIPetitionerDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.DialogService }, { type: i7.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-petitioner-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIPetitionerDetails, BasePetitionerDetailsLibraryService, DeleteDialogConfigurations, NoteDialogConfigurations };
//# sourceMappingURL=base-petitioner-details-library.js.map
